export default "__VITE_ASSET__BrmFA4pm__"